import { get, set } from '@helpers/cookie';
import { isFeatureActive } from '@helpers/index';

const cookieConsentGroups = {
    strictlyNecessary: 'C0001',
    functional: 'C0002',
    marketing: 'C0004',
};

export const hasGrantedConsentGroup = () => {
    if (!isFeatureActive('T80061_cookie_consent') && !isFeatureActive('PLT-3019_cookie_consent')) {
        return true;
    }

    const optanonConsent = get('OptanonConsent');

    if (!optanonConsent) {
        return true;
    }

    return optanonConsent.indexOf(`${cookieConsentGroups.marketing}:1`) !== -1;
};

export const initCookies = () => {
    // @ts-ignore
    const { domainName = 'boozt.com', language, store } = App.Config;

    set('language', language, {
        expires: 365,
        path: '/',
        domain: `.${domainName}`,
    });

    // @ts-ignore
    App.Config.hasGrantedConsentGroup = hasGrantedConsentGroup();

    if (hasGrantedConsentGroup()) {
        set('store', store, {
            expires: 365,
            path: '/',
            domain: `.${domainName}`,
        });
    }
};
